<template>
  <div class="mortgage-progress-group-select-component" v-bind:class="{loaded}">
    <a-radio-group button-style="solid" v-bind:default-value="null" v-on:change="onChange" v-if="loaded">
      <a-radio-button v-if="allOption" v-bind:value="null">
        Alle documenten
      </a-radio-button>
      <a-radio-button
          v-for="mortgageProgressGroup in mortgageProgressGroups"
          v-bind:key="mortgageProgressGroup.id"
          v-bind:value="mortgageProgressGroup">
        {{ mortgageProgressGroup.name }}
      </a-radio-button>
    </a-radio-group>
    <Skeleton v-else height="32px" style="display: block;" v-bind:loading="true" width="200px"></Skeleton>
  </div>
</template>

<script>
import mortgageProgressGroupApi from '~/api/mortgage_progress_group'
import { Skeleton } from 'vue-loading-skeleton'

export default {
  name: 'MortgageProgressGroupSelectComponent',
  components: {
    Skeleton
  },
  props: {
    value: {
      required: false,
      default: null
    },
    allOption: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mortgageProgressGroups: [],
      loaded: false,
    }
  },
  mounted () {
    this.initMortgageProgressGroups().then(() => {
      this.loaded = true
    })
  },
  computed: {
    mortgageProgressGroupedByStatus () {
      return this.mortgageProperties
    }
  },
  methods: {
    initMortgageProgressGroups () {
      return mortgageProgressGroupApi.all(['document_types']).then(response => {
        this.mortgageProgressGroups = response.data
      })
    },
    onChange (e) {
      this.$emit('change', e.target.value)
    }
  }
}
</script>
<style scoped>

</style>
